import { AfterViewInit, ChangeDetectorRef, Directive, ElementRef, HostListener, Input, Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { NgModel } from '@angular/forms';

@Pipe({
    name: 'currencyFormat',
    standalone: false
})
export class CurrencyFormatPipe implements PipeTransform {

  constructor(
    private readonly decimalPipe: DecimalPipe
  ) {

  }

  transform(value: string, digitsInfo = "1.0-0"): string {
    return this.decimalPipe.transform(value.replaceAll(".",  "").replace(",","."), digitsInfo, "da");
  }

  parse(value: string): string {
    return value.replaceAll(".","");//.replace(",",".");
  }

}

@Directive({
    selector: "[currencyFormat]",
    standalone: false
})
export class CurrencyFormatterDirective implements AfterViewInit {
  @Input("currencyFormat") digitsInfo: string;

  private readonly el: HTMLInputElement;

  constructor(
    private readonly cd: ChangeDetectorRef,
    private readonly elementRef: ElementRef,
    private readonly model: NgModel,
    private readonly currencyPipe: CurrencyFormatPipe
  ) {
    this.el = this.elementRef.nativeElement;
    model.options = {
      standalone: true,
      updateOn: 'submit'
    };
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.el.value) {
        this.el.value = this.currencyPipe.transform(this.el.value, this.digitsInfo) || null;
      }
    });
  }

  @HostListener("focus", ["$event"])
  onFocus(event: FocusEvent) {
    const value = (event.target as HTMLInputElement)?.value ?? "";
    // Ensure the raw (unformatted) value is shown while editing
    this.el.value = "" + this.currencyPipe.parse(value);
    // Explicitly select the full text after we change the value, so tab-focus always selects all
    // Using a microtask to let the focus event finish and Material apply classes first
    setTimeout(() => {
      try {
        this.el.select();
      } catch {}
    });
  }

  @HostListener("blur", ["$event"])
  onBlur(event: FocusEvent) {
    const value = (event.target as HTMLInputElement)?.value ?? "";
    this.model.update.emit(value.replaceAll(".","").replace(",","."));
    setTimeout(() => {
      this.el.value = this.currencyPipe.transform(value, this.digitsInfo) || null;
    });
    return true;
  }

}
